<script setup>
import { useAppNavMenuMobileState } from '@/core/composables/useAppNavMenuMobileState'

const props = defineProps({
  size: {
    type: String,
    default: '24',
  },
})

const { t } = useI18n()

const { isOpen } = useAppNavMenuMobileState()
</script>

<template>
  <div>
    <button
      class="touch-target text-black"
      :aria-label="t('Open menu')"
      @click="isOpen = !isOpen"
    >
      <DSIcon
        icon="i-fas-bars"
        :size="props.size"
      />
    </button>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Open menu": "Open menu"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Open menu": "Menü öffnen"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Open menu": "Ouvrir le menu"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Open menu": "Abrir menú"
}
</i18n>
